import ko from "knockout";
import { Listview } from "../../../listview";
import { CustomError, customFetch as fetch } from "../../../fetch";
import {closePopups} from "../../../init"
import h from "virtual-dom/h";
import SelectListItemModel from "../../../custom/selectlist-item-model";
import { formatDecimal } from "../../../decimal-utils";
import { errorToast, successToast } from "../../../toastr-helper";

export default class DocumentInfo {
    parent: any;
    
    documentName: KnockoutObservable<string>;
    document: KnockoutObservable<any>;
    submittedAgreement: KnockoutObservable<boolean>;
    
    signatureRequired: KnockoutObservable<boolean>;
    selectedType: KnockoutObservable<string>;
    
    types: KnockoutObservable<SelectListItemModel>;
    feeFactors: KnockoutObservable<SelectListItemModel>;
    validationErrors: KnockoutObservableArray<CustomError>;
    agreementError: KnockoutObservable<string>;

    WithoutPensionFee: KnockoutObservable<number>;
    WithoutPensionFeeAnalysis: KnockoutObservable<number>;
    WithPensionFee: KnockoutObservable<number>;
    WithPensionFeeAnalysis: KnockoutObservable<number>;
    UnderTwentyOnePensionFee: KnockoutObservable<number>;
    UnderTwentyOnePensionFeeAnalysis: KnockoutObservable<number>;
    AboveTwentyOnePensionFee: KnockoutObservable<number>;
    AboveTwentyOnePensionFeeAnalysis: KnockoutObservable<number>;

    partnershipAgreementIsSelected: KnockoutComputed<boolean>;
    feeFactorIsIncrementFactor: KnockoutComputed<boolean>;
    loading: KnockoutObservable<boolean>;

    listview: Listview;
    constructor(parent: any, partnershipAgreementTypes : any, feeFactorTypes : any) {
        this.parent = parent;

        this.validationErrors = ko.observableArray<CustomError>();
        this.agreementError = ko.observable<string>('').extend({
            errorHandler: { source: this.validationErrors, id: 'Agreements' }
        });
        
        this.signatureRequired = ko.observable<boolean>(false);
        this.selectedType = ko.observable<string>()
            .extend({
                errorHandler: { source: this.validationErrors, id: 'Type'}
            });

        this.WithoutPensionFee = ko.pureComputed({
            read: () => this.parent.financeInfo().employeeWithoutPensionFee(),
            write: (value: number) => this.parent.financeInfo().employeeWithoutPensionFee(value)
        });
        this.WithoutPensionFeeAnalysis = ko.pureComputed({
            read: () => this.parent.financeInfo().employeeWithoutPensionFeeAnalysis(),
            write: (value: number) => this.parent.financeInfo().employeeWithoutPensionFeeAnalysis(value)
        });
        this.WithPensionFee = ko.pureComputed({
            read: () => this.parent.financeInfo().employeeWithPensionFee(),
                write: (value: number) => this.parent.financeInfo().employeeWithPensionFee(value)
            });
        this.WithPensionFeeAnalysis = ko.pureComputed({
            read: () => this.parent.financeInfo().employeeWithPensionFeeAnalysis(),
                    write: (value: number) => this.parent.financeInfo().employeeWithPensionFeeAnalysis(value)
                });
        this.UnderTwentyOnePensionFee = ko.pureComputed({
            read: () => this.parent.financeInfo().employeeUnderTwentyOnePensionFee(),
                        write: (value: number) => this.parent.financeInfo().employeeUnderTwentyOnePensionFee(value)
                    });
        this.UnderTwentyOnePensionFeeAnalysis = ko.pureComputed({
            read: () => this.parent.financeInfo().employeeUnderTwentyOnePensionFeeAnalysis(),
                            write: (value: number) => this.parent.financeInfo().employeeUnderTwentyOnePensionFeeAnalysis(value)
                        });
        this.AboveTwentyOnePensionFee = ko.pureComputed({
            read: () => this.parent.financeInfo().employeeAboveTwentyOnePensionFee(),
                                write: (value: number) => this.parent.financeInfo().employeeAboveTwentyOnePensionFee(value)
                            });
        this.AboveTwentyOnePensionFeeAnalysis = ko.pureComputed({
            read: () => this.parent.financeInfo().employeeAboveTwentyOnePensionFeeAnalysis(),
                                    write: (value: number) => this.parent.financeInfo().employeeAboveTwentyOnePensionFeeAnalysis(value)
                                });
        
        this.types = ko.observable<SelectListItemModel>(partnershipAgreementTypes.map((pat: any) => new SelectListItemModel(pat)));
        this.feeFactors = ko.observable<SelectListItemModel>(feeFactorTypes.map((ff: any) => new SelectListItemModel(ff)));
        this.partnershipAgreementIsSelected = ko.computed<boolean>(() => this.selectedType() === '1');
        this.loading = ko.observable(false);
        
        this.documentName = ko.observable<string>('')
        this.document = ko.observable<any>()

        this.submittedAgreement = ko.observable<boolean>(false);
        
        this.listview = new Listview({
            rootElementId: 'partnershipAgreements',
            pagerOptions: { pagerElementId: 'partnershipAgreements-pager' },
            defaultOrder: [['originalCreated', 'desc']],
            getItems: async () => {
                const response = await fetch(`/Admin/PartnershipAgreement/GetAll/${parent.companyId}`);

                if (response.ok) {
                    return response.data;
                }

                return [];
            },
            columns: [
                {
                    position: 1,
                    header: 'Bestandsnaam',
                    property: 'fileName'
                },
                {
                    position: 3,
                    header: 'Type',
                    property: 'type'
                },
                {
                    position: 4,
                    header: 'Digitaal tekenen',
                    property: 'signatureRequired',
                },
                {
                    position: 5,
                    header: 'Aangemaakt door',
                    property: 'createdBy',
                },
                {
                    position: 6,
                    header: 'Datum',
                    property: 'created',
                },
                {
                    position: 7,
                    header: 'Verstuurd naar',
                    property: 'sendTo',
                },
                {
                    position: 8,
                    header: 'Status',
                    property: 'signingStatus',
                },
                {
                    position: 9,
                    props: { className: 'text-right' },
                    actions: [
                        {
                            name: 'Downloaden',
                            position: 1,
                            render: (item: any) => {
                                let icon = h('i', { className: 'fa fa-download' }, []);

                                return h('a', {
                                    href: `/Admin/PartnershipAgreement/Download/${item.id}`,
                                    title: 'Downloaden'
                                }, [icon]);
                            }
                        }
                    ]
                },
                {
                    position: 10,
                    props: { className: 'text-right' },
                    actions: [
                        {
                            name: 'Versturen',
                            position: 1,
                            show: (item: any) => item.signingStatus === 'Nog niet verstuurd' && item.signatureRequired === 'Ja',
                            render: () => {
                                let icon = h('i', { className: 'fa fa-envelope' }, []);

                                return h('a', {
                                    href: `#`,
                                    title: 'Versturen'
                                }, [icon]);
                            },
                            type: 'confirm-popup',
                            confirmText: 'Weet u zeker dat u dit document wilt versturen?',
                            onConfirm: async (item: any) => {
                                const fd = new FormData();
                                fd.append('id', item.id);

                                await fetch(`/Admin/PartnershipAgreement/Send/${item.id}`, {
                                    method: 'POST',
                                    body: fd
                                });

                                this.listview.load();
                            }
                        }
                    ]
                },
                {
                    position: 11,
                    props: { className: 'text-right' },
                    actions: [
                        {
                            name: 'Verwijderen',
                            position: 2,
                            render: () => {
                                let icon = h('i', { className: 'fa fa-times' }, []);

                                return h('a', {
                                    href: '#',
                                    title: 'Verwijderen'
                                }, [icon]);
                            },
                            type: 'confirm-popup',
                            confirmText: 'Weet u zeker dat u dit document wilt verwijderen?',
                            onConfirm: async (item: any) => {
                                const fd = new FormData();
                                fd.append('id', item.id);

                                await fetch(`/Admin/PartnershipAgreement/Delete`, {
                                    method: 'DELETE',
                                    body: fd
                                });

                                this.listview.preProcessedItems = this.listview.preProcessedItems.filter(f => f.id !== item.id);
                                this.listview.build();
                            }
                        }
                    ]
                }
            ]
        });

        this.listview.load();
    }
    
    closePopup() {
        closePopups();
    }

    async submit() {
        this.loading(true);
        const fd = new FormData();

        fd.append('fileName', this.documentName());
        fd.append('file', this.document().file());
        fd.append('companyId', this.parent.companyId);
        fd.append('type', this.selectedType().toString());

        if (this.partnershipAgreementIsSelected()) {
            fd.append('signatureRequired', this.signatureRequired().toString());
            if (this.signatureRequired()) {
                fd.append('WithoutPensionFee', this.WithoutPensionFee().toString());
                fd.append('WithoutPensionFeeAnalysis', this.WithoutPensionFeeAnalysis().toString());
                fd.append('WithPensionFee', this.WithPensionFee().toString());
                fd.append('WithPensionFeeAnalysis', this.WithPensionFeeAnalysis().toString());
                fd.append('UnderTwentyOnePensionFee', this.UnderTwentyOnePensionFee().toString());
                fd.append('UnderTwentyOnePensionFeeAnalysis', this.UnderTwentyOnePensionFeeAnalysis().toString());
                fd.append('AboveTwentyOnePensionFee', this.AboveTwentyOnePensionFee().toString());
                fd.append('AboveTwentyOnePensionFeeAnalysis', this.AboveTwentyOnePensionFeeAnalysis().toString());
                
                this.parent.submit();
            }
        }

        const response = await fetch('/Admin/PartnershipAgreement/Create', {
            method: 'POST',
            body: fd
        });
        
        if(response.ok) {
            successToast("overeenkomst opgeslagen")
        } else if (response.data) {
            if(response.data.errors) {
                response.data.errors.forEach((e) => {
                        errorToast(e.message);
                });
                
                this.validationErrors(response.data.errors);
            }
        }
        this.listview.load();
        this.closePopup();
        
        this.loading(false);
    }

    async validateModel() {
        const url = `/admin/CompanyOnboarding/ValidateSignedAgreement/${this.parent.companyId}`;

        const response = await fetch(url, {
            method: 'GET',
        });

        if (!response.ok) {
            this.parent.validationIsSuccessful = false;
            if (response.errors && response.errors.length > 0) {
                this.validationErrors(response.errors);
            }
        }
    }
}
